import { randomLetter } from './randomLetter';

/**
 * Generates a random string of specified length containing only lowercase letters.
 * @param {number} n - The length of the string to generate
 * @returns {string} A random string of length n
 * @example
 * randomString(5) // returns a random 5-character string like 'abcde'
 */
export const randomString = (n: number): string =>
    [...Array(n)].map(() => randomLetter()).join('');
